export default __webpack_public_path__ + "minus-ring-fill.6b348663da069745.svg";